export default "__VITE_ASSET__de49faf0__"